import Button from "@/components/common/Button";
import WebIcon from "@/components/common/Web_Icons";
import PropTypes from "prop-types";

const ActionButtons = ({ onDelete, onModify }) => {
  return (
    <div className="w-full mt-4 overflow-hidden">
      <div className="flex gap-2 overflow-x-auto pb-2 hide-scrollbar max-w-full">
        <Button
          text="MODIFY"
          icon={
            <WebIcon
              icon="Edit1"
              size="large"
              className="w-[18px] h-[18px] ml-2"
            />
          }
          customBgColor="white"
          customTextColor="lighterGrey"
          className="whitespace-nowrap h-[36px] text-small border border-primary flex-shrink-0"
          onClick={onModify}
        />
        <Button
          text="DELETE"
          icon={
            <WebIcon
              icon="Trash"
              size="large"
              className="w-[18px] h-[18px] ml-2"
            />
          }
          customBgColor="white"
          customTextColor="lighterGrey"
          className="whitespace-nowrap h-[36px] text-small border border-primary flex-shrink-0"
          onClick={onDelete}
        />
        <Button
          text="MESSAGE"
          icon={
            <WebIcon
              icon="TwinMessage"
              size="large"
              className="w-[18px] h-[18px] ml-2"
            />
          }
          customBgColor="white"
          customTextColor="lighterGrey"
          className="whitespace-nowrap h-[36px] text-small border border-primary flex-shrink-0"
        />
      </div>
    </div>
  );
};

ActionButtons.propTypes = {
  onDelete: PropTypes.func,
  onModify: PropTypes.func,
};

export default ActionButtons;
